import { ReactNode } from 'react';

interface JobTaskCalendarTextProps {
  children: ReactNode;
}

export const JobTaskCalendarText = ({ children }: JobTaskCalendarTextProps) => (
  <span className="mt-0.5 whitespace-nowrap text-xs font-medium text-neutral-700">{children}</span>
);
